import { routesTemplate } from "../routesTemplate";

import HomeScreen from "../../screens/home/HomeScreen";
import NewsScreen from "../../screens/news/NewsScreen";
import NewsReadingScreen from "../../screens/news/NewsReadingScreen";

export const homeStack = [
    routesTemplate('/home', HomeScreen, "Home"),
    routesTemplate('/news', NewsScreen),
    routesTemplate('/news/reader', NewsReadingScreen)

];
